<template>
  <div class="homemobile">
    <br><br>

    <b-container fluid style="padding-top:10px;width:100%">

      <!-- HEADER -->
      <b-row>
        <b-col cols="12">
          <HeaderMobile/>
        </b-col>
      </b-row>

      <!-- MARQUEE (FIRST) -->
      <b-row style="color:#424242;height:2vh;margin-top:2vh;margin-bottom:0vh">
        <marquee loop="2" style="display:block">
          <span v-for="item in getMarquee" :key="item.title">
            <span class="m-text" v-html="item.title"></span>
            <span> | </span>
          </span>
        </marquee>
      </b-row>
       <!-- APP UPDATE RIBBON -->
      <b-row class="mt-2">
        <b-col cols="12">
          <div class="app-update-ribbon">
            <b-icon icon="info-circle-fill" class="mr-2"></b-icon>
            <span>
              Users facing issues with the
              <strong>Android version of the myBijulee mobile application</strong>
              are advised to update it to the
              <strong>latest version available on the Google Play Store</strong>.
            </span>
          </div>
        </b-col>
      </b-row>
     <!---<b-row class="mt-2">
        <b-col cols="12">
          <div class="notification-qr">
           
            <div class="text-center">
              <a
                href="https://result.assam.statedatacenter.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click here to download appointment letters for the post of Sahayak in APDCL
              </a>
            </div>
          </div>
        </b-col>
      </b-row>-->
<!---
     
      <b-row class="mt-3">
        <b-col cols="12">
          <div class="notification-qr">
            <div class="notification-image">
              <img src="../assets/QR_ADRE_AppointmentLetters.png" />
            </div>
            <div class="text-center mt-2">
              <a
                href="https://result.assam.statedatacenter.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click here to download appointment letters for the post of Sahayak in APDCL
              </a>
            </div>
          </div>
        </b-col>
      </b-row>
<br>
     
      <b-row>
        <b-col cols="12">
          <div class="notification">
            The appointment letter of the
            <strong>
              Candidates selected in APDCL for the post of Sahayak under reservation of
              Tea Tribe and Adivasi category
            </strong>
            will be distributed on
            <strong>
              12.01.2026 at 02:00 PM at GMC Auditorium, Gauhati Medical College.
            </strong>
            Please bring your <strong>ADRE admit card</strong> as the sole document of identification.
          </div>
        </b-col>
      </b-row>
    -->
      <!-- BANNER (AFTER NOTIFICATION) -->
      <b-row class="mt-3">
        <b-col cols="12" class="banner-mb">
          <Banner/>
        </b-col>
      </b-row>

     

      <!-- CUSTOMER SUPPORT -->
      <b-row>
        <b-col cols="12">
          <router-link
            to="/ContactCustomerCare"
            custom
            target="_blank"
            class="customer-support-banner"
          >
            <div>
              For any electricity-related issues, contact our
              <strong>24x7 Customer Support</strong> at
              <strong>
                1912 (Calls from Assam) / 0361–3126201 or 0361-2803200 (Outside Assam)
              </strong>
              or email at <strong>support@apdcl.org</strong>
            </div>
            <div style="margin-top:8px;">
              (বিদ্যুৎ সম্পৰ্কীয় যিকোনো সমস্যাৰ বাবে আমাৰ
              <strong>২৪x৭ গ্ৰাহক সহায়ক নম্বৰ</strong>
              <strong>
                ১৯১২ (অসমৰ পৰা) / ০৩৬১–৩১২৬২০১ বা ০৩৬১–২৮০৩২০০ (অসমৰ বাহিৰৰ পৰা)
              </strong>
              বা <strong>support@apdcl.org</strong> ই-মেইল কৰক)
            </div>
          </router-link>
        </b-col>
      </b-row>

      <!-- PAYMENT -->
      <b-row class="mt-3">
        <b-col cols="12" class="payment-mb">
          <MobilePayment/>
        </b-col>
      </b-row>

      <!-- CARDS -->
      <b-row class="mt-3">
        <b-col cols="12">
          <HomepageMobileCardComponents/>
        </b-col>
      </b-row>

      <!-- FOOTER -->
      <b-row class="mt-3">
        <b-col cols="12">
          <FooterMobile/>
        </b-col>
      </b-row>

    </b-container>

    <!-- STARTUP MODAL -->
    <b-modal
      id="startupModal"
      size="l"
      centered
      title="Be Alert,Be Safe!!"
      :static="true"
      hide-footer
    >
      <b-img
        src="https://www.apdcl.org/website/docs/gallery/banner/scamalert2.jpg"
         class="img-fluid"
        style="border:1px solid grey;"
      />
    </b-modal>
  <!--- <ChatBot />-->
  </div>
</template>


<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import Banner from '@/components/HomeBanner.vue'
import MobilePayment from '@/components/HomeMobilePayment.vue'
import MobileBottomFixedNav from '@/components/HomeMobileBottomFixedNav.vue'
import HomepageMobileCardComponents from '@/components/HomeMobileCardComponents.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import FooterMobile from '@/components/FooterMobile.vue'
import ChatBot from '@/views/ChatBot.vue';
//import MarqueeText from 'vue-marquee-text-component'
//console.log(Banner);
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'HomeMobile',
  components: {
    'Banner' : Banner,
    'MobilePayment' : MobilePayment,
    'MobileBottomFixedNav' : MobileBottomFixedNav,
    'HomepageMobileCardComponents' : HomepageMobileCardComponents,
    'HeaderMobile' : HeaderMobile,
    'FooterMobile' : FooterMobile,
     'ChatBot': ChatBot
    //MarqueeText

  },

data() {
    return {
     getMarqueeFields: [
         { key: 'title', label: '' }

       ]
    }

},
computed:
{
  ...mapGetters([
    'getMarquee'
  ])
},
methods: {
  ...mapActions([
    'retrieveMarquee'

  ]),
},
beforeMount() {
    if(this.getMarquee.length == 0){
      this.retrieveMarquee();

    }
},
mounted()
{
  this.$bvModal.show('startupModal');
}
}

</script>


<style>
.app-update-ribbon {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  background: linear-gradient(90deg, #fff3e0, #ffcc80);
  color: #e65100;

  padding: 12px 16px;
  border-left: 6px solid #fb8c00;
  border-radius: 6px;

  font-size: 0.85rem;
  font-weight: 600;

  text-align: center;
  margin-bottom: 10px;
  margin-left: 20px;

  /* Pulse animation 
  animation: pulse-orange 1s infinite;
}

@keyframes pulse-orange {
  0% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0.45); /* orange */
 /* }
  70% {
    box-shadow: 0 0 0 10px rgba(245, 124, 0, 0.4); /* deep orange 
  }
  100% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0);
  }*/
}

.app-update-ribbon svg {
  margin-right: 2px;
  font-size: 0.95rem;
}
.notification {
  display: block;
  background-color: #f4ffe1;
  
  color: #444;
  /* border-left: 6px solid #ff9800; */
  border-left: 6px solid #fb8c00;
  border-right: 6px solid #fb8c00;
  border-top: 6px solid #fb8c00;
  border-bottom: 6px solid #fb8c00;
  padding: 10px 10px;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  border-radius: 10px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.15);
  /* margin: 10px auto; */
  /* max-width: 1000px; */
  margin-bottom: 1px;
  margin-left: 20px;
  line-height: 1.6;
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  animation: pulse-orange 1s infinite;



  
}
@keyframes pulse-orange {
  0% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0.45); /* orange */
  }
  70% {
    box-shadow: 0 0 0 10px rgba(245, 124, 0, 0.4); /* deep orange */
  }
  100% {
    box-shadow: 0 0 0 0 rgba(251, 140, 0, 0);
  }
}

.notification-image {
  text-align: center;
  margin-bottom: 10px;
}

.notification-image img {
  width: 140px;          /* small & clean */
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  padding: 6px;
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
}

.customer-support-banner {
  display: block;
  background-color: #fff8e1; /* sticky-note look */
  /* border-left: 6px solid #ff9800; */
  border-left: 6px solid #0277bd;
  border-right: 6px solid #0277bd;
  border-top: 6px solid #0277bd;
  border-bottom: 6px solid #0277bd;
  /* padding: 16px 20px; */
  border-radius: 10px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.15);
  color: #333;
  text-decoration: none;
  font-weight: 500;
  line-height: 1.6;
   margin-left:20px;
  /* max-width: 1000px; */
  /* margin: 10px auto; */
  margin-top: 10px;
  margin-bottom: 5px;
  transition: all 0.2s ease-in-out;
}

.customer-support-banner:hover {
  background-color: #ffecb3;
  box-shadow: 4px 6px 14px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
  cursor: pointer;
}

.customer-support-banner .support-line {
  display: block;
  font-size: 1rem;
  margin-bottom: 4px;
}
.homeMobile {
  margin-top: -25px;
  height:102vh;
  background-image: url('../assets/bg4.jpg');

 background-repeat: no-repeat;
 background-attachment: fixed;
 background-size: 100% 100%;
 box-shadow:inset 0 0 0 2000px  #ffffffbf;;

}
.banner-mb{
  /* display:none; */
  display: block;
}
.payment-mb{
  display:block;
}

/* @media only screen and (max-width: 768px) {
  .banner-pc{
    display:none;
  }
  .payment-pc{
    display:none;
  }
  .banner-mb{
    display:block;
  }
  .payment-mb{
    display:block;
  }
} */
.m-text{
  padding:10px 10px 0px 10px;
}
@media (min-width: 768px) {

  }
@media only screen and (max-width: 600px) {
  /* body {
    background-color: lightblue;
  } */
}
@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial,Assamese_Font;
}


</style>
